import { render, staticRenderFns } from "./ImolaceramicaLogo.vue?vue&type=template&id=3dc886a4&scoped=true&"
var script = {}
import style0 from "./ImolaceramicaLogo.vue?vue&type=style&index=0&id=3dc886a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc886a4",
  null
  
)

export default component.exports